var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"col-md-5 col-lg-4"},[_c('AllDevicesSummary')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }